<template>
  <div id="wrapper" class="page">
    <meeting-side-bar index="1" />
    <div id="content-wrapper">
      <div id="booking_schedule_fulid" class="container-fluid">
        <div class="mydiv">
          <b-row>
            <b-col
              style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px; padding-left: 0px;"
            >
              <button
                class="btn-sm btn-outline-secondary border-0 float-left"
                style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                @click.prevent="$refs.vuecal.previous()"
              >
                <i
                  style="font-size: 31px !important;"
                  class="fas fa-angle-left"
                ></i>
              </button>
              <button
                class="btn-sm btn-outline-secondary border-0 float-left"
                style="background-color: #fde3c1; margin-left:3px;"
                id="popover-target-1"
              >
                <i
                  class="fas fa-filter"
                  style="font-size: 22px !important; padding: 2px 0px 2px 0px;"
                ></i>
              </button>
            </b-col>
            <template>
              <b-col
                id="btn-booking-calendar-type-1"
                style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px; margin-right:4px;"
              >
                <div
                  style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem;"
                >
                  <button
                    class="btn-sm border-0 button--pandora"
                    style="width: 80px; padding: 4px 4px 4px 4px; "
                    @click.prevent="changeActiveView('day')"
                  >
                    Day
                  </button>
                </div>
              </b-col>
              <b-col
                id="btn-booking-calendar-type-1"
                style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px;  margin-right:4px;"
              >
                <div
                  style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem;"
                >
                  <button
                    class="btn-sm border-0 button--pandora"
                    style="width: 80px; padding: 4px 4px 4px 4px; "
                    @click.prevent="changeActiveView('week')"
                  >
                    Week
                  </button>
                </div>
              </b-col>
              <b-col
                id="btn-booking-calendar-type-1"
                style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px;  margin-right:6px;"
              >
                <div
                  style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem;"
                >
                  <button
                    class="btn-sm border-0 button--pandora"
                    style="width: 80px; padding: 4px 4px 4px 4px;"
                    @click.prevent="changeActiveView('month')"
                  >
                    Month
                  </button>
                </div>
              </b-col>
            </template>
            <template>
              <b-col
                id="btn-booking-calendar-type-2"
                style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px; padding-left: 0px;"
              >
                <b-dropdown
                  size="sm"
                  variant="outline-secondary"
                  toggle-class="btn-booking-calendar-type border-0"
                  style="    background-color: cadetblue;"
                  no-caret
                >
                  <template #button-content>
                    <i
                      class="fas fa-calendar-day"
                      style="font-size: 25px !important;"
                    ></i>
                  </template>
                  <b-dropdown-item-button
                    style=""
                    @click.prevent="changeActiveView('day')"
                    >Day</b-dropdown-item-button
                  >
                  <b-dropdown-item-button
                    style="outline: unset; width:99px"
                    @click.prevent="changeActiveView('week')"
                    >Week</b-dropdown-item-button
                  >
                  <b-dropdown-item-button
                    style="outline: unset; width:99px"
                    @click.prevent="changeActiveView('month')"
                    >Month</b-dropdown-item-button
                  >
                </b-dropdown>
              </b-col>
            </template>
            <b-col
              style="flex-grow: 1; font-size: 20px; font-weight: bold;"
              class="text-center"
            >
              {{ $convert_date_string_master(this.startDate) }}
            </b-col>
            <b-col
              id="btn-booking-calendar-type-1"
              style="width: 160px; max-width: 160px; padding-right: 0px;padding-left: 0px;"
            ></b-col>
            <b-col
              style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px;"
            >
              <div
                style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem;"
              >
                <button
                  class="btn-sm border-0 button--pandora"
                  style="width: 80px; padding: 4px 2px 4px 4px; "
                  @click.prevent="openModal"
                  v-if="meetingevent_create"
                >
                  <i
                    class="fas fa-plus-circle"
                    style="float: left; font-size: 23px;"
                  ></i>
                  Book
                </button>
              </div>
            </b-col>
            <b-col
              style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px;padding-left: 0px;"
            >
              <button
                class="btn-sm btn-outline-secondary border-0 float-right"
                style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                @click.prevent="$refs.vuecal.next()"
              >
                <i
                  style="font-size: 31px !important;"
                  class="fas fa-angle-right"
                ></i>
              </button>
              <button
                class="btn-sm btn-outline-secondary border-0 float-right"
                style="padding-top:4px; padding-bottom:3px; background-color: #fde3c1; margin-right:3px;"
                @click.prevent="$refs.vuecal.switchView('month', new Date())"
              >
                <i
                  style="font-size: 25px !important;"
                  class="fas fa-map-marker-alt "
                ></i>
              </button>
            </b-col>
          </b-row>
        </div>
        <b-popover
          id="booking_schedule_popover_fulid"
          target="popover-target-1"
          triggers="click blur"
          placement="top"
        >
          <template v-slot:title>
            Please select Room/Car/Equipment
          </template>
          <b-form-group>
            <b-form-checkbox-group
              v-model="meetingSelected"
              :options="meetings"
              value-field="id"
              text-field="name"
              @input="changeMeetingSelected"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
        </b-popover>

        <vue-cal
          id="vuecal_meeting_events"
          ref="vuecal"
          hide-view-selector
          hide-title-bar
          :disable-views="['years', 'year']"
          today-button
          locale="en"
          :time-from="8 * 60"
          :time-to="20 * 60"
          :events="items"
          :time-step="30"
          :on-event-click="openUpdateModal"
          @hidden="closeModal"
          @ready="viewChange"
          @view-change="viewChange"
          :active-view.sync="activeView"
          events-on-month-view="short"
        >
          <template v-slot:split-label="{ split }">
            <i class="far fa-building"></i>
            <strong>{{ split.label }}</strong>
          </template>
          <template v-slot:cell-content="{ cell }">
            <span
              class="vuecal__cell-date m-1"
              :style="{
                color:
                  cell.class == 'vuecal__cell--day6' ||
                  cell.class == 'vuecal__cell--day7'
                    ? cell.outOfScope != true
                      ? '#ffb284'
                      : '#ffb38280'
                    : '',
              }"
              ><div>
                {{ cell.content }}
              </div>
            </span>
          </template>
          <template v-slot:weekday-heading="{ heading }">
            <div
              style="font-weight:bold; width: 100%; border-radius:3px; "
              :style="change_weekdays_headings_color(heading.label)"
            >
              {{ heading.label.substring(0, 3) }}
            </div>
          </template>
          <template v-slot:no-event>{{&nbsp;}}</template>
          <template v-slot:event="{ event }">
            <div
              style="height: 100%; color: #000;  border-radius: 3px; margin: 0px 5px 5px 5px;"
              :style="[
                event.status == 0
                  ? {
                      'border-style': 'solid',
                      'border-width': '5px',
                      'background-color': '#fff',
                      'border-color': event.color,
                    }
                  : {
                      'border-style': 'solid',
                      'border-width': '5px',
                      'background-color': event.color,
                      'border-color': event.color,
                    },
              ]"
            >
              <div
                v-if="
                  findMeeting(event.meetingId) == 'TEST COVID 19' &&
                    event.status == 1
                "
                class="vuecal__event-title"
                v-html="findMeeting(event.meetingId)"
                style="color:white;font-weight: bold;"
              ></div>
              <div
                v-else
                class="vuecal__event-title"
                v-html="findMeeting(event.meetingId) + ': ' + event.title"
              />

              <div
                v-if="
                  findMeeting(event.meetingId) == 'TEST COVID 19' &&
                    event.status == 1
                "
                class="vuecal__event-time"
                style="color:white;font-weight: bold;"
              >
                <span>
                  {{ event.start | moment("HH:mm") }} -
                  {{ event.end | moment("HH:mm") }}
                </span>
              </div>
              <div v-else class="vuecal__event-time">
                <span v-if="findMeeting(event.meetingId) == 'Van - 16 seats'">
                  <img
                    src="../assets/icon_Van.png"
                    height="19px"
                    width="28px"
                    style="float:left"
                  />
                  {{ event.start | moment("HH:mm") }} -
                  {{ event.end | moment("HH:mm") }}
                  <!-- <span v-html="message"></span> -->
                </span>

                <span
                  v-else-if="findMeeting(event.meetingId) == 'Innova - 7 seats'"
                >
                  <img
                    src="../assets/icon_Innova.png"
                    height="17px"
                    width="28px"
                    style="float:left"
                  />

                  {{ event.start | moment("HH:mm") }} -
                  {{ event.end | moment("HH:mm") }}
                  <!-- <span v-html="message"></span> -->
                </span>

                <span
                  v-else-if="findMeeting(event.meetingId) == 'Meeting Room'"
                >
                  <img
                    src="../assets/icon_Meeting.png"
                    height="17px"
                    width="28px"
                    style="float:left"
                  />

                  {{ event.start | moment("HH:mm") }} -
                  {{ event.end | moment("HH:mm") }}
                  <!-- <span v-html="message"></span> -->
                </span>

                <span
                  v-else-if="
                    findMeeting(event.meetingId) == 'Fitting & Casting Area'
                  "
                >
                  <img
                    src="../assets/icon_FittingCasting.png"
                    height="17px"
                    width="28px"
                    style="float:left"
                  />

                  {{ event.start | moment("HH:mm") }} -
                  {{ event.end | moment("HH:mm") }}
                  <!-- <span v-html="message"></span> -->
                </span>

                <span
                  v-else-if="findMeeting(event.meetingId) == 'Present Room 1'"
                >
                  <img
                    src="../assets/icon_Present.png"
                    height="17px"
                    width="28px"
                    style="float:left"
                  />

                  {{ event.start | moment("HH:mm") }} -
                  {{ event.end | moment("HH:mm") }}
                  <!-- <span v-html="message"></span> -->
                </span>

                <span
                  v-else-if="findMeeting(event.meetingId) == 'Present Room 2'"
                >
                  <img
                    src="../assets/icon_Present.png"
                    height="17px"
                    width="28px"
                    style="float:left"
                  />

                  {{ event.start | moment("HH:mm") }} -
                  {{ event.end | moment("HH:mm") }}
                  <!-- <span v-html="message"></span> -->
                </span>

                <span v-else>
                  {{ event.start | moment("HH:mm") }} -
                  {{ event.end | moment("HH:mm") }}
                </span>
                <!-- class="d-inline-block align-left" -->
              </div>
            </div>
          </template>
        </vue-cal>
      </div>
    </div>
    <b-modal
      v-model="modalShow"
      id="modal_add_meeting_booking"
      size="lg"
      centered
      scrollable
      content-class="shadow"
      header-bg-variant="info"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="is_creating">Add Schedules</div>
        <div v-else>Update Schedule</div>
      </template>
      <b-form autocomplete="off">
        <b-row v-if="is_booking_account">
          <b-col>
            <b-form-group label="Phòng họp">
              <template v-slot:label>
                Requester's Email
                <span class="text-danger">*</span>
              </template>
              <b-form-input
                type="email"
                v-model="item.emailrequest"
                :disabled="item.id > 0 && item.emailrequest == null"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Phòng họp">
              <template v-slot:label>
                Rooms | Cars | Equipment
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="item.meetingId"
                :options="meetings_list"
                value-field="id"
                text-field="name"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Phòng họp">
              <template v-slot:label>
                Job
                <span class="text-danger">*</span>
              </template>

              <b-form-select
                v-if="is_creating && is_car_booking(item.meetingId)"
                v-model="production.id"
                :options="productions"
                value-field="id"
                text-field="job"
              ></b-form-select>
              <b-form-input v-else v-model="item.title" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- #region Không sử dụng timeSpanOptions nữa do chị Anna và phạm hương thảo yêu
        cầu - Changed 24 04 2023 -->
        <!-- <b-row>
          <b-col>
            <b-form-group>
              <b-form-radio-group
                v-model="item.time_span"
                :options="timeSpanOptions"
                class="mb-3"
                value-field="value"
                text-field="text"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row> -->
        <!-- MORNING AND AFTERNOON -->
        <!-- <b-row v-if="item.time_span == 0 || item.time_span == 1">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Date
                <span class="text-danger">*</span>
              </template>
              <date-picker
                v-model="item.allDay_from"
                type="date"
                locale="en"
                format="DD/MM/YYYY"
              />
            </b-form-group>
          </b-col>
        </b-row> -->
        <!-- END OF MORNING AND AFTERNOON -->

        <!-- ALL DAY -->
        <!-- <b-row v-if="item.time_span == 2">
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                Start Date
                <span class="text-danger">*</span>
              </template>
              <date-picker
                v-model="item.allDay_from"
                type="date"
                locale="en"
                format="DD/MM/YYYY"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                End Date
                <span class="text-danger">*</span>
              </template>
              <date-picker
                v-model="item.allDay_to"
                type="date"
                locale="en"
                format="DD/MM/YYYY"
              />
            </b-form-group>
          </b-col>
        </b-row> -->
        <!-- END OF ALL DAY -->
        <!-- #endregion -->

        <!-- CUSTOM DATE -->
        <!-- <b-row v-if="item.time_span == 3"> -->
        <b-row>
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                Start time
                <span class="text-danger">*</span>
              </template>
              <date-picker
                v-model="item.start"
                type="datetime"
                locale="en"
                format="DD/MM/YYYY HH:mm"
                :locale-config="localeConfigs"
                :scroll="true"
                :jumpMinute="30"
                :roundMinute="true"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>
                End time
                <span class="text-danger">*</span>
              </template>
              <date-picker
                v-model="item.end"
                type="datetime"
                locale="en"
                :locale-config="localeConfigs"
                format="DD/MM/YYYY HH:mm"
                :scroll="true"
                :jumpMinute="30"
                :roundMinute="true"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- END OF CUSTOM DATE -->
        <b-row>
          <b-col>
            <b-form-group label="Note">
              <b-form-input v-model="item.content" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Attach File">
              <template
                v-slot:label
                v-if="
                  this.item.meetingId == this.$meeting_van16 ||
                    this.item.meetingId == this.$meeting_testCovid
                "
              >
                Attach File
                <span class="text-danger">*</span>
              </template>

              <b-form-file
                v-if="item.filename == null"
                v-model="tepdinhkemfile"
                placeholder="Please click here to attach timeline..."
                browse-text="..."
              ></b-form-file>
              <div v-else>
                <a
                  :href="
                    `../attach/meetingevent/${this.item.id}/` +
                      this.item.filename
                  "
                  target="_blank"
                  >{{ this.item.filename }} &nbsp;&nbsp;&nbsp;&nbsp;</a
                >
                <b-link
                  class="text-danger"
                  href="#"
                  @click.prevent="deleteFile"
                >
                  <i class="fas fa-trash"></i>
                </b-link>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="item.hovaten != null && !is_booking_account">
          <b-col>
            <b-form-group label="Requester">
              <b-form-input
                v-if="item.emailrequest == null"
                v-model="item.hovaten"
                readonly
              ></b-form-input>
              <b-form-input
                v-else
                v-model="item.emailrequest"
                readonly
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-form inline>
                <b-button
                  v-if="
                    (item.id > 0 &&
                      item.status == 0 &&
                      meetingevent_update &&
                      same_user) ||
                      meetingevent_duyet ||
                      (item.id <= 0 && meetingevent_create)
                  "
                  variant="info"
                  @click.prevent="submitEvent"
                  :disabled="disable_save_button"
                >
                  <i class="fas fa-save mr-2"></i>Save
                </b-button>
                <!-- <b-link class="mr-4" href="#" @click.prevent="storeItem"
                v-if="((item.id > 0 && meetingevent_update) || (item.id <= 0 && meetingevent_create))"
                >
                  <i class="fas fa-edit mr-2"></i> Lưu
                </b-link>-->
                <div style="flex-grow: 1" />
                <b-button
                  class="mr-2"
                  v-if="item.id > 0 && item.status == 0 && meetingevent_duyet"
                  variant="success"
                  @click.prevent="approveItem"
                  :disabled="disable_save_button"
                >
                  <i class="fas fa-check-square mr-2"></i>Approve
                </b-button>
                <b-button
                  v-if="
                    (item.id > 0 &&
                      item.status == 0 &&
                      meetingevent_delete &&
                      same_user) ||
                      (item.id > 0 && meetingevent_duyet)
                  "
                  variant="danger"
                  @click.prevent="openDeleteModal"
                  :disabled="disable_save_button"
                >
                  <i class="fas fa-trash mr-2"></i> Delete
                </b-button>
                <!-- <b-link
                  v-if="item.id >0 && item.status == 0 && meetingevent_duyet"
                  class="text-success mr-4"
                  href="#"
                  @click.prevent="approveItem"
                >
                  <i class="fas fa-check-square mr-2"></i> Chấp nhận lịch
                </b-link>-->
                <!-- <b-link
                  v-if="item.id > 0 && item.status == 0 && meetingevent_delete"
                  class="text-danger"
                  href="#"
                  @click.prevent="deleteItem"
                >
                  <i class="fas fa-trash mr-2"></i> Xóa lịch
                </b-link>-->
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal
      id="modal_del_meeting_booking"
      centered
      scrollable
      v-model="deleteModalShow"
      header-bg-variant="danger"
      header-text-variant="light"
      hide-footer
      title="Do you really delete this schedule?"
    >
      <b-form autocomplete="false">
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Reason
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="item.comment"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-button
                class="mr-2"
                variant="danger"
                @click.prevent="deleteItem"
                :disabled="disable_save_button"
              >
                <i class="fas fa-trash mr-2"></i>Delete
              </b-button>
              <b-button
                class="mr-2"
                variant="secondary"
                @click.prevent="closeDeleteModal"
              >
                <i class="fas fa-times mr-2"></i>Cancel
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import MeetingSideBar from "../components/Meeting/MeetingSideBar";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/vi.js";
import "vue-cal/dist/vuecal.css";

// import VueDatepickerLocal from "vue-datepicker-local";
// import "vue-datepicker-local/dist/vue-datepicker-local.css";
export default {
  name: "MeetingEvents",
  components: {
    MeetingSideBar,
    VueCal,
    //VueDatepickerLocal,
  },
  data() {
    return {
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },
      localeConfigs: {
        vi: {
          dow: 1,
          dir: "ltr",
          displayFormat: (vm) => {
            return vm.type === "datetime" ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY";
          },
          lang: {
            submit: "Chọn",
            cancel: "Thoát",
            now: "Hiện tại",
          },
        },
        en: {
          dow: 1,
          dir: "ltr",
        },
      },
      // timeSpanOptions: [
      //   { value: 0, text: "Morning" },
      //   { value: 1, text: "Afternoon" },
      //   { value: 2, text: "All day" },
      //   { value: 3, text: "Others" },
      // ],
      activeView: "month",
      meetings: [],
      meetings_list: [],
      production: { id: null, job: "" },
      productions: [],
      meetingSelected: null,
      is_creating: false,
      modalShow: false,
      items: [],
      item_null: {
        id: 0,
        title: null,
        meetingId: null,
        content: null,
        start: null,
        end: null,
        status: 0,
        hovaten: null,
        // allDay: null,
        // allDay_from: null,
        // allDay_to: null,
        comment: null,
        emailrequest: null,
        // time_span: 0,
      },
      item: {
        id: 0,
        title: null,
        meetingId: null,
        content: null,
        start: null,
        end: null,
        status: 0,
        hovaten: null,
        // allDay: null,
        // allDay_from: null,
        // allDay_to: null,
        comment: null,
        manhanvien: 0,
        emailrequest: null,
        filename: "",
        // time_span: 0,
      },
      // job_input_type: true,
      disable_save_button: false,
      startDate: null,
      endDate: null,
      // allDay: true,
      url: "/api/meetingevent/",
      deleteModalShow: false,
      last_meetingSelected: null,
      full_meetingSelected: null,
      tepdinhkemfile: null,
      message: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
    };
  },
  watch: {
    //update: commented 24 04 2023
    // "item.allDay_from": function(newValue, oldValue) {
    //   this.item.allDay_to = newValue;
    // },
  },
  computed: {
    meetingevent_read() {
      return this.$store.getters.hasPermission("meetingevent_read");
    },
    meetingevent_create() {
      return this.$store.getters.hasPermission("meetingevent_create");
    },
    meetingevent_update() {
      return this.$store.getters.hasPermission("meetingevent_update");
    },
    meetingevent_delete() {
      return this.$store.getters.hasPermission("meetingevent_delete");
    },
    meetingevent_duyet() {
      return this.$store.getters.hasPermission("meetingevent_duyet");
    },
    same_user() {
      return this.$store.state.auth.name == this.item.manhanvien;
    },
    is_booking_account() {
      return this.$store.state.auth.name == this.$booking_account;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/meeting/use"),
        axios.get("/api/meeting/production"),
      ])
      .then(
        axios.spread((use, production) => {
          next((vm) => vm.initData(use.data, production.data));
        })
      )
      .catch((err) => {
        `2`;
        next();
      });
  },
  mounted() {
    function calendar_change(type_) {
      const btn_cal_t1 = document.querySelectorAll(
        "#btn-booking-calendar-type-1"
      );
      if (document.documentElement.clientWidth <= 960) {
        btn_cal_t1.forEach((element) => {
          element.style.display = "none";
        });
        document.querySelector("#btn-booking-calendar-type-2").style.display =
          "block";
      } else if (
        btn_cal_t1[0].style.display == "none" ||
        type_ == "firstLoad"
      ) {
        btn_cal_t1.forEach((element) => {
          element.style.display = "block";
        });
        document.querySelector("#btn-booking-calendar-type-2").style.display =
          "none";
        /*eslint-disable-next-line no-console*/
        // console.log(event);
      }
    }
    calendar_change("firstLoad"); //run first load page
    window.addEventListener(
      "resize",
      function(event) {
        calendar_change("addEventListener");
      },
      true
    );
  },
  methods: {
    initData(uses, productions) {
      this.meetings = uses;
      this.meetings_list = this.meetings.slice();
      this.productions = productions;
      this.meetingSelected = [];

      const select_all = { id: -1, name: "All" };
      this.meetings.unshift(select_all);

      const select_null = {
        id: null,
        name: "Please select Room/Car/Equipment",
      };
      this.meetings_list.unshift(select_null);
      this.productions.unshift({
        id: null,
        job: "Please select Job",
      });
      for (let i = 0; i < uses.length; i++) {
        this.meetingSelected.push(uses[i].id);
      }

      this.last_meetingSelected = this.meetingSelected;
      this.full_meetingSelected = this.meetingSelected;

      this.getEvents();
    },
    findMeeting(id) {
      const temp = this.meetings.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.name;
    },
    is_car_booking(meetingId) {
      const temp = this.meetings.find(function(el) {
        if (el.id == meetingId) return el;
      });
      return temp != null ? (temp.name.match("seats") ? true : false) : false;
    },
    findProduction(id) {
      const temp = this.productions.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.job;
    },
    findProductionId(job) {
      const temp = this.productions.find(function(el) {
        if (el.job == job) return el;
      });
      return temp == null ? null : temp.id;
    },
    changeMeetingSelected() {
      // Find out if lost -1, deselect all
      if (
        this.meetingSelected.length < this.last_meetingSelected.length &&
        this.last_meetingSelected.indexOf(-1) != -1 &&
        this.meetingSelected.indexOf(-1) == -1
      ) {
        this.meetingSelected = [];
      } // Find out if gain -1, select all
      else if (
        this.meetingSelected.length > this.last_meetingSelected.length &&
        this.meetingSelected[this.meetingSelected.length - 1] == -1
      ) {
        this.meetingSelected = this.full_meetingSelected;
      }

      this.getEvents();
      this.last_meetingSelected = this.meetingSelected;
    },
    changeActiveView(view) {
      this.activeView = view;
    },
    viewChange(obj) {
      this.startDate = obj.startDate;
      this.endDate = obj.endDate;
      this.getEvents();
    },
    getEvents() {
      if (this.meetingSelected != null) {
        let meetingid = "";
        for (let i = 0; i < this.meetingSelected.length; i++) {
          if (i != 0) meetingid += ",";
          meetingid += this.meetingSelected[i];
        }

        axios
          .get("/api/meetingevent", {
            params: {
              meetingid: meetingid,
              start: this.startDate.getTime(),
              end: this.endDate.getTime(),
            },
          })
          .then((response) => {
            this.items = response.data;
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          });
      }
    },
    openModal() {
      if (!(this.meetings_list && this.meetings_list.length)) {
        this.$toast.error(
          "There's no room or car or equipment exists, please create one!",
          "Error",
          { timeout: 3000 }
        );
      }
      this.item = JSON.parse(JSON.stringify(this.item_null));
      this.is_creating = true;
      this.disable_save_button = false;
      // this.job_input_type = true;
      this.item.meetingId = null;
      this.item.title = null;
      this.production.id = null;
      this.production.job = "";
      // this.allDay = true;
      this.modalShow = true;
    },
    closeModal() {
      this.is_creating = false;
      this.disable_save_button = false;
      this.modalShow = false;
    },
    openUpdateModal(event, e) {
      this.item = JSON.parse(JSON.stringify(this.item_null));
      // this.allDay = false;
      this.item.id = event.id;
      this.item.title = event.title;
      this.item.meetingId = event.meetingId;
      this.item.content = event.content;
      this.item.start = this.$moment(event.start).format("DD/MM/YYYY HH:mm");
      this.item.end = this.$moment(event.end).format("DD/MM/YYYY HH:mm");
      // .add(1, 'minutes')
      this.item.status = event.status;
      this.item.hovaten = event.hovaten;
      this.item.manhanvien = event.manhanvien;
      this.item.emailrequest = event.emailrequest;
      this.item.filename = event.filename;
      this.tepdinhkemfile = event.filename; //gan tepdinhkemfile
      // this.item.time_span = 3;
      // this.item.allDay_from = this.$moment(event.start).format("DD/MM/YYYY");
      this.production.id = this.findProductionId(event.title);

      this.is_creating = false;
      // this.job_input_type = false;
      this.disable_save_button = false;
      this.modalShow = true;
    },
    //update: commented 24 04 2023
    // changeAllDay() {
    //   if (this.allDay && this.item.start && this.item.start.length) {
    //     this.item.allDay = this.item.start.substring(
    //       0,
    //       this.item.start.indexOf("T")
    //     );
    //   } else if (
    //     !this.allDay &&
    //     this.item.allDay_from &&
    //     this.item.allDay_from.length
    //   ) {
    //     this.item.start = `${this.item.allDay_from}T00:00`;
    //     this.item.end = `${this.item.allDay_to}T23:59`;
    //   }
    // },
    submitEvent() {
      this.disable_save_button = true;
      if (
        this.is_booking_account &&
        (this.item.emailrequest == null || this.item.emailrequest == "")
      ) {
        this.$error_message("Please enter requester email");
        this.disable_save_button = false;
        return;
      }

      if (
        this.is_booking_account &&
        !this.$email_format_regex.test(this.item.emailrequest)
      ) {
        this.$error_message("Request Email field is not in the correct format");
        this.disable_save_button = false;
        return;
      }

      // VAN-16 SEAT FORCE TO HAVE ATTACH FILE
      if (
        this.item.meetingId == this.$meeting_van16 &&
        this.tepdinhkemfile == null
      ) {
        this.$error_message("Van-16 must have an attached file!");
        this.disable_save_button = false;
        return;
      }

      // TEST COVID FORCE TO HAVE ATTACH FILE
      if (
        this.item.meetingId == this.$meeting_testCovid &&
        this.tepdinhkemfile == null
      ) {
        this.$error_message("Test Covid must have an attached file!");
        this.disable_save_button = false;
        return;
      }
      // #region timeSpanOptions - Changed 24 04 2023
      // THIS IS FOR ALL DAY
      // if (
      //   this.item.time_span == 2 &&
      //   this.item.allDay_from &&
      //   this.item.allDay_to &&
      //   this.item.allDay_from.length &&
      //   this.item.allDay_to.length
      // ) {
      //   if (
      //     !(
      //       this.item.allDay_from &&
      //       this.item.allDay_from &&
      //       this.item.allDay_from.length &&
      //       this.item.allDay_to.length
      //     )
      //   ) {
      //     this.item.start = "";
      //     this.item.end = "";
      //   } else {
      //     this.item.start = `${this.$swap_date_format(
      //       this.item.allDay_from
      //     )}T00:00`;
      //     this.item.end = `${this.$swap_date_format(
      //       this.item.allDay_to
      //     )}T23:59`;
      //   }
      // }
      // THIS IS FOR MORNING
      // if (
      //   this.item.time_span == 0 &&
      //   this.item.allDay_from &&
      //   this.item.allDay_from.length
      // ) {
      //   this.item.allDay_to = this.item.allDay_from;
      //   this.item.start = `${this.$swap_date_format(
      //     this.item.allDay_from
      //   )}T00:00`;
      //   this.item.end = `${this.$swap_date_format(this.item.allDay_to)}T11:59`;
      // }
      // THIS IS FOR AFTERNOON
      // if (
      //   this.item.time_span == 1 &&
      //   this.item.allDay_from &&
      //   this.item.allDay_from.length
      // ) {
      //   this.item.allDay_to = this.item.allDay_from;
      //   this.item.start = `${this.$swap_date_format(
      //     this.item.allDay_from
      //   )}T12:00`;
      //   this.item.end = `${this.$swap_date_format(this.item.allDay_to)}T23:59`;
      // }
      // #endregion

      // FINAL CHECK BEFORE WE GO
      if (
        // !(this.item.title && this.item.title.length) ||
        (this.is_creating && this.is_car_booking(this.item.meetingId)
          ? !this.production.id
          : !(this.item.title && this.item.title.length)) ||
        !(this.item.start && this.item.start.length) ||
        !(this.item.end && this.item.end.length) ||
        !this.item.meetingId
      ) {
        this.$toast.error("Please fill out all necessary fields", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
        return;
      }

      if (this.item.end <= this.item.start) {
        this.$toast.error(
          "End time have to be later than Start time",
          "Error",
          {
            timeout: 2000,
          }
        );
        this.disable_save_button = false;
        return;
      }

      // CONVERT DATE WHEN THERE IS TIME INVOLVE update: commented 24 04 2023
      // if (this.item.time_span == 3) {
      this.item.start = this.convert_date_with_time(this.item.start);
      this.item.end = this.convert_date_with_time(this.item.end)
        .replace(":00", ":59")
        .replace(":30", ":29"); // trùng mốc thời gian đến - ví dụ: 9h:00 - 12h00 và 12h00 - 13h00
      // }

      // FIRE AWAY
      if (this.is_creating) this.addEvent();
      else this.updateEvent();
    },
    addEvent() {
      if (this.tepdinhkemfile != null)
        this.item.filename = this.tepdinhkemfile.name;
      if (this.is_car_booking(this.item.meetingId))
        this.item.title = this.findProduction(this.production.id);
      axios
        .post("/api/meetingevent", this.item)
        .then((res) => {
          this.items.push(res.data);

          if (this.tepdinhkemfile != null) {
            const formData = new FormData();
            formData.append("file", this.tepdinhkemfile);
            formData.append("meetingeventid", res.data.id);

            axios
              .post("/api/meetingevent/uploadfile", formData)
              .catch((err) =>
                this.$toast.error("" + err, "Error", { timeout: 3000 })
              );
            this.disable_save_button = false;
          }

          this.closeModal();
          this.tepdinhkemfile = null;
          this.$toast.success("Save Successfully !", "Success", {
            timeout: 3000,
          });

          // @EMAIL
          axios
            .post(`/api/sendemail/sendlichphonghopemail/${res.data.mailid}`)
            .catch((err) =>
              this.$toast.error("" + err, "Error", { timeout: 3000 })
            );
          this.disable_save_button = false;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          this.disable_save_button = false;
        });
    },
    updateEvent() {
      // this.item.title = this.findProduction(this.production.id);
      axios
        .put("/api/meetingevent", this.item)
        .then((res) => {
          const itemIndex = this.items.findIndex((x) => x.id === res.data.id);

          this.items[itemIndex] = JSON.parse(JSON.stringify(res.data));
          //file khong thay doi
          if (
            this.tepdinhkemfile != null &&
            this.tepdinhkemfile != this.items[itemIndex].filename
          ) {
            const formData = new FormData();
            formData.append("file", this.tepdinhkemfile);
            formData.append("meetingeventid", res.data.id);

            axios
              .post("/api/meetingevent/uploadfile", formData)
              .then((rec) => {
                this.items[itemIndex].filename = rec.data.uniqueName;
              })
              .catch((err) =>
                this.$toast.error("" + err, "Error", { timeout: 3000 })
              );
            this.disable_save_button = false;
          }

          const temp = JSON.parse(JSON.stringify(this.items));
          this.items = JSON.parse(JSON.stringify(temp));

          this.$toast.success("Save Successfully !", "Success", {
            timeout: 3000,
          });
          this.tepdinhkemfile = null;
          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          this.disable_save_button = false;
        });
    },
    approveItem() {
      this.disable_save_button = true;
      axios
        .put(`${this.url}approve/${this.item.id}`)
        .then((res) => {
          const itemIndex = this.items.findIndex((x) => x.id === this.item.id);
          this.items[itemIndex].status = 1;
          this.closeModal();
          axios
            .post(`/api/sendemail/sendlichphonghopemail/${res.data.id}`)
            .catch((err) =>
              this.$toast.error("" + err, "Error", { timeout: 3000 })
            );
          this.disable_save_button = false;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          this.disable_save_button = false;
        });
    },
    openDeleteModal() {
      this.deleteModalShow = true;
    },
    closeDeleteModal() {
      this.deleteModalShow = false;
    },
    deleteItem() {
      this.disable_save_button = true;
      if (!(this.item.comment && this.item.comment.length)) {
        this.$toast.error("Please enter reason", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
      } else {
        // if (this.item.time_span == 3) {
        this.item.start = this.convert_date_with_time(this.item.start);
        this.item.end = this.convert_date_with_time(this.item.end)
          .replace(":00", ":59")
          .replace(":30", ":29"); // trùng mốc thời gian đến - ví dụ: 9h:00 - 12h00 và 12h00 - 13h00
        // }
        axios
          .patch(this.url, this.item)
          .then((res) => {
            const itemIndex = this.items.findIndex(
              (x) => x.id === this.item.id
            );
            this.items.splice(itemIndex, 1);
            this.$toast.success("Delete successfully", "Success", {
              timeout: 3000,
            });
            this.disable_save_button = false;
            this.deleteModalShow = false;
            this.modalShow = false;
            axios
              .post(`/api/sendemail/sendlichphonghopemail/${res.data.id}`)
              .catch((err) =>
                this.$toast.error("" + err.response, "Error", { timeout: 3000 })
              );
            this.disable_save_button = false;
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Errror", {
              timeout: 3000,
            });
            this.$toast.error(
              "" +
                this.item.end +
                " " +
                this.convert_date_with_time(this.item.end)
                  .replace(":00", ":59")
                  .replace(":30", ":29"),
              "Error",
              {
                timeout: 6000,
              }
            );
            this.disable_save_button = false;
          });
      }
    },
    convert_date_with_time(dt) {
      var datetime = dt.split(" ");
      var date = datetime[0];
      var time = datetime[1];

      // return this.$swap_date_format(date) + "T" + datetime[1];
      return this.$swap_date_format(date) + "T" + time;
    },
    deleteFile() {
      this.item.filename = null;
      this.tepdinhkemfile = null;
      this.$forceUpdate();
    },
    change_weekdays_headings_color(day_name) {
      if (day_name == "Sunday" || day_name == "Saturday") {
        return { "background-color": "#ffb284" };
      } else {
        return { "background-color": "#ffd18b" };
      }
    },
  },
};
</script>
<style>
.btn-booking-calendar-type {
  padding-top: 1px;
  padding-bottom: 1px;
  background-color: #fde3c1 !important;
  box-shadow: none !important;
}
#booking_schedule_fulid .mydiv {
  min-height: 40px;
  height: unset;
}
#booking_schedule_fulid .dropdown-menu {
  min-width: 101px;
}
#booking_schedule_fulid .dropdown-menu button {
  outline: unset;
  width: 99px;
}
#booking_schedule_fulid .vuecal {
  height: calc(100vh - 120px);
}
#modal_add_meeting_booking .modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 6rem);
}
#booking_schedule_fulid.container-fluid {
  height: calc(100vh - 80px);
}
/* #vuecal_meeting_events .vuecal__cell--today:before {
  background-color: #8b8d8c;
  border: 2px solid #777777;
} */
#vuecal_meeting_events .vuecal__cell--selected:before {
  border: 2px solid rgb(66, 185, 131);
  background-color: rgba(113, 113, 112, 0.1);
}
div#booking_schedule_popover_fulid.popover {
  max-width: 190px;
}
</style>
